export enum Role {
  All = "All",
  Admin = "Admin",
  Doctor = "Doctor",
  Patient = "Patient",
  Administrator = "Administrator",
  SuperAdministrator = "SuperAdministrator",
  Teacher = "Teacher",
  SuperStockist = "Superstockist Admin",
  Stockist = "Stockist Admin",
  Plr = "PLR Admin",
  Student = "Student",
  Accounts = "Accounts",
}
